module.exports = __webpack_public_path__ + "static/media/wishlist-remove.809859b1.svg";